"use client"

import * as React from "react"
import { Share2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { ShareModal } from "@/components/leagues/share-modal"
import type { League } from "@/lib/leagues-data"

interface ShareButtonProps {
  league: League
  variant?: "default" | "outline" | "ghost"
  className?: string
}

export function ShareButton({ league, variant = "outline", className }: ShareButtonProps) {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Button
        variant={variant}
        size="lg"
        onClick={() => setOpen(true)}
        className={`gap-2 border-border ${className || ""}`}
      >
        <Share2 className="h-5 w-5" />
        Invite Friends
      </Button>
      <ShareModal
        open={open}
        onOpenChange={setOpen}
        league={league}
      />
    </>
  )
}
